import { Link } from 'react-router-dom';
import { getPopularComics } from '@/mocks/comics';

export default function PopularComics() {
  const popularComics = getPopularComics(10);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热门排行
            </h2>
            <p className="mt-2 text-sm text-foreground-500">最受读者欢迎的韩国漫画</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-product-shop="">
          {popularComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="flex items-center gap-3">
                <span className={`font-heading text-xl md:text-2xl font-bold w-8 text-center ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="relative w-16 md:w-20 flex-shrink-0 rounded-lg overflow-hidden aspect-[3/4] bg-background-200">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 韩国漫画热门排行`}
                    title={`${comic.title} - 免费韩漫大全热门作品`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">{comic.description}</p>
                <div className="mt-2 flex items-center gap-3 flex-wrap">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    {comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-heart-line"></i>
                    {comic.likes > 10000 ? `${(comic.likes / 10000).toFixed(0)}万` : comic.likes}
                  </span>
                  <span className={`px-2 py-0.5 text-xs rounded-full ${
                    comic.status === 'completed'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}>
                    {comic.status === 'completed' ? '已完结' : '连载中'}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}